export const AI_DASHBOARD_ALLOWED_EMAILS = [
  "info@oysterbaywatersports.com",
  "pramender.singh+admin@ditstek.com",
]

export const DEFAULT_RANGE = "month"

export const RANGE_OPTIONS = {
  date: "Day",
  week: "Week",
  month: "Month"
}
